import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormikTextField } from '../../../common/formik-material-ui';

const useStyles = makeStyles((theme: Theme) => ({
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
  },
  smsField: {
    minHeight: '9em',
  },
}));

export const AddSMSTemplateTab = ({ formik }) => {
  const classes = useStyles();
  return (
    <main className="col">
      <div>
        <FormikTextField
          name="SMSTemplate.name"
          className={classes.field}
          formik={formik}
          fullWidth
          InputProps={{
            inputProps: {
              maxLength: 100,
            },
          }}
          label="Name"
          size="small"
          required
          variant="outlined"
        />
      </div>

      <div>
        <FormikTextField
          name="SMSTemplate.content"
          className={`${classes.field}`}
          formik={formik}
          fullWidth
          InputProps={{
            inputProps: {
              maxLength: 512,
            },

            classes: {
              input: classes.smsField,
            },
          }}
          label="Template"
          size="small"
          multiline
          required
          variant="outlined"
        />
      </div>
    </main>
  );
};
